import axios from 'axios'

import { getBaseUrl } from 'utils/baseUrls'
import { getNodeEnv, isTestEnvironment } from 'utils/environment'

const GREMLIN_AGENT = `support/${getNodeEnv()}`
const HOSTNAME_REGEX = /(.*\w\.|.*\/)gremlin\.com/

const baseURL = `${getBaseUrl('support')}/v1`
const API = axios.create({
  baseURL,
  adapter: isTestEnvironment() ? 'http' : 'xhr'
})
API.interceptors.request.use((config) => {
  if (config.url && HOSTNAME_REGEX.test(config.url)) {
    config.headers['X-Gremlin-Agent'] = GREMLIN_AGENT // eslint-disable-line no-param-reassign
  }
  return config
})

export default API
